




import React, { Component } from 'react';

// import BeatTrap from '../Musics/BeatTrap.mp3';
// import BeatTrap from '../Musics/BeatTrap.mp3'

import AudioAnalyser from '../AudioAnalyser';

// let ctx;
// const width = window.innerWidth;
// const height = window.innerHeight;

export default class MusicsScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            audio: null,
            // mp3: null
        };
        this.toggleMicrophone = this.toggleMicrophone.bind(this);
        // this.toggleMp3File = this.toggleMp3File.bind(this);
    }

    async getMicrophone() {
        const audio = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
        });
        this.setState({ audio });
    }

    stopMicrophone() {
        this.state.audio.getTracks().forEach(track => track.stop());
        this.setState({ audio: null });
    }

    toggleMicrophone() {
        if (this.state.audio) {
            this.stopMicrophone();
        } else {
            this.getMicrophone();
        }
    }

    vibrate = () => window.navigator.vibrate(200);



    render() {
        return(
            <button onClick={this.toggleMicrophone}>
                {this.state.audio ? 'Stop microphone' : 'Get microphone input'}
                { this.state.audio ? <AudioAnalyser audio={this.state.audio} /> : '' }
            </button>
        );
    }

}
/*
    constructor(props){
        super(props);

        this.audio = new Audio(BeatTrap);
        this.canvas = createRef();
    }

    animationLooper(canvas) {
        canvas.width = width;
        canvas.height = height;

        ctx = canvas.getContext("2d");
    }

    togglePlay = () => {
        let { audio } = this;
        if(audio.paused) {
            audio.play();
            this.rafId = requestAnimationFrame(this.tick);

         } else {
            audio.pause();
            cancelAnimationFrame(this.rafId);
         }
    }

    draw() {
        const { audioData } = this.props;
        const canvas = this.canvas.current;
        const height = canvas.height;
        const width = canvas.width;
        const context = canvas.getContext('2d');
        let x = 0;
        const sliceWidth = (width * 1.0) / audioData.length;
    
        context.lineWidth = 2;
        context.strokeStyle = '#000000';
        context.clearRect(0, 0, width, height);
    
        context.beginPath();
        context.moveTo(0, height / 2);
        for (const item of audioData) {
          const y = (item / 255.0) * height;
          context.lineTo(x, y);
          x += sliceWidth;
        }
        context.lineTo(x, height / 2);
        context.stroke();
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.rafId);
        this.analyser.disconnect();
        this.source.disconnect();
    }

    render(){
        return <>
            <button onClick={this.togglePlay}>Play/Pause</button>
            <canvas ref={this.canvas}  />
        </>

        // return(
        //     <div>
        //         <button>Beat Trap</button>
        //     </div>
        // );
    }
} 


*/